interface ParagraphLike {
  paragraphIndex?: number;
  content?: string | null;
}

const COLUMN_STYLES = {
  content: {
    height: '100%',
    display: 'inline-block',
    verticalAlign: 'top',
    overflow: 'hidden',
    columnWidth: '100vw',
    columnFill: 'auto',
    columnGap: '0',
    width: 'auto'
  },
  block: { padding: '0 17px' },
  p: {
    whiteSpace: 'pre-wrap' as const,
    fontFamily: '"Noto Serif KR", ui-serif, Georgia, "Times New Roman", serif',
    fontSize: '18px',
    lineHeight: '40px'
  },
  span: { lineHeight: '40px' }
};

function createLocatorContentElement(paragraphs: ParagraphLike[], episodeId: string): HTMLElement {
  const content = document.createElement('div');
  Object.assign(content.style, COLUMN_STYLES.content);

  const block = document.createElement('div');
  Object.assign(block.style, COLUMN_STYLES.block);

  paragraphs.forEach((paragraph) => {
    const p = document.createElement('p');
    Object.assign(p.style, COLUMN_STYLES.p);
    p.dataset.sceneEpisodeId = episodeId;
    p.dataset.paragraphIndex = String(paragraph.paragraphIndex ?? 0);

    const text = paragraph.content ?? '';
    const tokens = text.split(/(\s+)/);
    let charOffset = 0;

    tokens.forEach((token) => {
      const startOffset = charOffset;
      charOffset += token.length;
      Array.from(token).forEach((ch, i) => {
        const span = document.createElement('span');
        span.textContent = ch;
        span.dataset.sceneEpisodeId = episodeId;
        span.dataset.paragraphIndex = String(paragraph.paragraphIndex ?? 0);
        span.dataset.charOffset = String(startOffset + i);
        Object.assign(span.style, COLUMN_STYLES.span);
        p.appendChild(span);
      });
    });

    block.appendChild(p);
  });

  content.appendChild(block);
  return content;
}

/**
 * paragraphIndex + charOffset이 위치한 페이지 인덱스를 반환합니다.
 * EpisodeBlock과 동일한 DOM 구조로 측정합니다.
 */
export const getPageIndexForLocator = (
  paragraphs: ParagraphLike[],
  episodeId: string,
  paragraphIndex: number,
  charOffset: number,
  pageWidth: number,
  effectiveContentHeight: number
): number => {
  if (paragraphs.length === 0) return 0;

  const host = document.createElement('div');
  host.style.position = 'fixed';
  host.style.left = '-9999px';
  host.style.top = '0';
  host.style.width = `${pageWidth}px`;
  host.style.height = `${effectiveContentHeight}px`;
  host.style.visibility = 'hidden';
  host.style.overflow = 'hidden';
  document.body.appendChild(host);

  try {
    const contentElement = createLocatorContentElement(paragraphs, episodeId);
    contentElement.style.columnWidth = '100vw';
    contentElement.style.width = 'auto';
    host.appendChild(contentElement);

    const target = contentElement.querySelector<HTMLElement>(
      `[data-scene-episode-id="${episodeId}"][data-paragraph-index="${paragraphIndex}"][data-char-offset="${charOffset}"]`
    );

    if (!target) return 0;

    const targetRect = target.getBoundingClientRect();
    const contentRect = contentElement.getBoundingClientRect();
    const xInContent = targetRect.left - contentRect.left;
    const pageIndex = Math.max(0, Math.floor(xInContent / pageWidth));

    return pageIndex;
  } finally {
    document.body.removeChild(host);
  }
};
